// Tiny pub/sub for in-flight upload progress, so UI far from the upload code
// (e.g. the top-bar storage indicator) can animate storage draining live.

export type UploadProgressEvent = {
  uploadId: string;
  totalBytes: number;
  loadedBytes: number;
  // Set when the upload finished (success or failure). On failure the bytes
  // are released (loadedBytes: 0).
  done?: boolean;
};

type Listener = (event: UploadProgressEvent) => void;

const listeners = new Set<Listener>();

export const publishUploadProgress = (event: UploadProgressEvent) => {
  listeners.forEach((listener) => listener(event));
};

export const subscribeUploadProgress = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

let uploadSeq = 0;
export const nextUploadId = () => {
  uploadSeq += 1;
  return `upload-${uploadSeq}`;
};

// ---- Storage freed (deletions) ----
// Published when a memory is deleted so the storage indicator can animate the
// space being returned.

type FreedListener = (freedBytes: number) => void;

const freedListeners = new Set<FreedListener>();

export const publishStorageFreed = (freedBytes: number) => {
  if (freedBytes <= 0) return;
  freedListeners.forEach((listener) => listener(freedBytes));
};

export const subscribeStorageFreed = (listener: FreedListener) => {
  freedListeners.add(listener);
  return () => {
    freedListeners.delete(listener);
  };
};
